import React from 'react'
import { cn } from './cn'

export interface CountBadgeProps {
  count: number
  className?: string
  /** Text placed before the number, e.g. `'+'` for a "how many more" badge. */
  prefix?: string
}

export function CountBadge({ count, className, prefix }: CountBadgeProps) {
  if (count === 0) return null

  return (
    <span className={cn('inline-grid h-[17px] min-w-[17px] place-items-center rounded-full bg-foreground px-1 font-mono text-3xs tabular-nums text-background', className)}>
      {prefix}
      {count}
    </span>
  )
}
